export const baseUrl = '/admins';
export const adminPagesUrl = {
  baseUrl,
  add: `${baseUrl}/add`,
  edit: (userId: string) => `${baseUrl}/${userId}/edit`,
};
